module.exports = __webpack_public_path__ + "img/27_67.9f501204.png";